import React, { memo } from "react";
import PropTypes from "prop-types";
import {
  ThemeProvider,
  StyledEngineProvider,
  createTheme,
} from "@mui/material/styles";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Button from "@mui/material/Button";
import Hidden from "@mui/material/Hidden";
import Typography from "@mui/material/Typography";
import link from "dan-api/ui/link";
import useStyles from "./landingStyle-jss";
import BannerParallax from "./BannerParallax";
import "./Landing.css";
import { Grid } from "@mui/material";
// import banner from "/app/images/banner.gif";
// import banner from "/app/images/banner.png";
import { purple, green, blue } from "@mui/material/colors";
import bannerBG from "/app/images/bg/education-bg-1.webp";
// import bannerFirst from "/app/images/banner/banner1.jpg";
// import bannerFirst from "/app/images/banner/IVP-platform.jpg";
import bannerFirst from "/app/images/banner/new-ivp-banner.webp";
import styled from "styled-components";
const theme = createTheme({
  palette: {
    primary: green,
    secondary: blue,
  },
});

// const bgIMAGE = {
//   // backgroundImage: 'url("/app/images/bg/education-bg-1.webp")',
//   // backgroundImage: 'url("/app/images/banner/banner1.jpg")',
//   backgroundImage: 'url("/app/images/banner/IVP-platform.jpg")',
//   backgroundImage: `url(${bannerFirst})`,
//   backgroundSize: "cover",
//   backgroundRepeat: "round",
// };

function Banner(props) {
  const { slideMode } = props;
  const { classes, cx } = useStyles();

  const gradient = useSelector((state) => state.ui.gradient);
  return (
    <div
    // className={` pt-4 ${cx(
    //   classes.banner,
    //   gradient ? classes.gradient : classes.solid,
    //   slideMode ? classes.out : classes.fit,
    //   classes.backgroundImage
    // )}`}
    // style={bgIMAGE}
    >
      {!slideMode && <BannerParallax />}

      <Grid container spacing={2} className="justify-content-center">
        <img src={bannerFirst} alt="ISEA Virtual PLateform" />

        {/* <Grid item md={6} xs={12}>
          <div
            className={` img1 ${cx(
              classes.m2,
              classes.screen,
              slideMode ? classes.bottom : ""
            )}`}
          >
            <img src={banner} alt="" />
          </div>
          <div className={classes.bannerScreen}>
            <img src={banner} alt="" />
          </div>
        </Grid>
        <Grid item md={6} xs={12}>
          <div className={!slideMode ? classes.container1 : ""}>
            <div className={` text-left ${classes.bannerHead}`}>
              <Typography component="h2" variant="h2" gutterBottom>
                Isea Virtual Platform
              </Typography>
              <Typography component="p" variant="h5" gutterBottom>
                ISEA resources as a single point of contact
              </Typography>
              <Typography component="p" variant="h5" gutterBottom>
                for all stakeholders of ISEA community.
              </Typography>
              <div className="text-left banerImage">
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={theme}>
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.margin}
                    >
                      Get Started
                    </Button>
                  </ThemeProvider>
                </StyledEngineProvider>
              </div>
            </div>
          </div>
        </Grid> */}
      </Grid>
    </div>
  );
}

Banner.propTypes = {
  slideMode: PropTypes.bool,
};

Banner.defaultProps = {
  slideMode: false,
};

const MemoedBanner = memo(Banner);
export default MemoedBanner;
